import { apiPaths, queryKeys } from 'api/kinerja/pengawas-sekolah/config'
import { useQueryApi } from 'utils/api'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { CommonResponse } from 'types/api'
import type { PengembanganKompetensiV2KegiatanAspects } from 'types/kinerja-ps-pegawai'

// Pengembangan Kompetensi
export function useAPIGetPengembanganKompetensiAspectOptions() {
  const { period } = usePeriodContext()
  return useQueryApi<CommonResponse<PengembanganKompetensiV2KegiatanAspects>>(
    apiPaths.pengembanganKompetensiV2Aspects(period.id),
    {
      queryConfig: {
        useErrorBoundary: false,
        staleTime: 60 * 60 * 1000, // 1 hour
        cacheTime: 60 * 60 * 1000, // 1 hour
      },
      queryKey: [queryKeys.API_GET_PENGEMBANGAN_KOMPETENSI_V2_ASPECT_OPTIONS],
    }
  )
}
